// extracted by mini-css-extract-plugin
module.exports = {"bottom_affix":"bottom_affix-39yMMRBS","backToTop":"backToTop-2MT4FGwY","floatAd":"floatAd-2WepubFi"};